import { useState } from "react";
import { Box, Typography } from "@mui/material";
import { NoDataFound } from "../../../../empty/Index";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { OrderDetails } from "./OrderDetails";

export const Tbody = ({ branchOrderData, generateForm }) => {

    const [open, setOpen] = useState(false)
    const [order, setOrder] = useState([])

    const viewOrder = (order) => {
        setOpen(true)
        setOrder(order)
    }

    return (
        <Box
            height="100%"
            overflowY="auto"
            width="100%"
            bgcolor="#FFFFFF"
            borderRadius="12px"
            className="overflowY"
            display="flex"
            flexDirection="column"
            gap="12px"
            p={2}
        >
            {/* EMPTY */}
            {(!generateForm.infiniteLoad && branchOrderData.length === 0) && (
                <Box sx={{ height: "100%" }}>
                    <NoDataFound />
                </Box>
            )}

            {/* DATA */}
            {(!generateForm.infiniteLoad && branchOrderData.length > 0) &&
                branchOrderData.map((v, k) => (
                    <Box
                        key={k}
                        sx={{
                            p: 2,
                            borderRadius: "12px",
                            boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
                            border: 1,
                            borderColor: "#c9c9c9ff"
                        }}
                    >
                        {/* Series */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>Series #:</Box>
                            <Typography fontSize={13} fontWeight={500}>
                                {v.series_num}
                            </Typography>
                        </Box>

                        {/* Branch */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>Branch:</Box>
                            <Typography fontSize={13}>
                                {v.name}
                            </Typography>
                        </Box>

                        {/* User */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>User:</Box>
                            <Typography fontSize={13}>
                                {v.first_name} {v.last_name}
                            </Typography>
                        </Box>

                        {/* Date */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>Date:</Box>
                            <Typography fontSize={13}>
                                {new Date(v.created_at).toLocaleString('en-US', {
                                    year: 'numeric',
                                    month: '2-digit',
                                    day: '2-digit',
                                    hour: '2-digit',
                                    minute: '2-digit',
                                    hour12: true
                                })}
                            </Typography>
                        </Box>

                        {/* Total */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>Total:</Box>
                            <Typography fontSize={13} fontWeight={600} color="primary.main">
                                ₱ {parseFloat(v.total_sales).toLocaleString('en-PH', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                            </Typography>
                        </Box>

                        {/* ACTION */}
                        <Box
                            mt={1}
                            display="flex"
                            justifyContent="flex-end"
                        >
                            <RemoveRedEyeOutlinedIcon
                                onClick={() => viewOrder(v)}
                                sx={{
                                    color: "primary.main",
                                    fontSize: 26,
                                    cursor: "pointer"
                                }}
                            />
                        </Box>
                    </Box>
                ))}

            {/* MODAL */}
            {open && (
                <OrderDetails
                    open={open}
                    setOpen={setOpen}
                    orderDetails={order}
                />
            )}
        </Box>
    )
}